import styled from 'styled-components';

/**
 * Marco del 404 de DENTRO de la aplicación. No pinta logo ni fondo propio: la
 * cabecera de `MainLayout` ya está arriba con el logo, el menú y el nombre del
 * usuario — que es justo lo que le dice al operario que sigue dentro. Aquí
 * solo se centra la tarjeta en el hueco del contenido.
 */
export const Container = styled.div`
  /* Ocupa el hueco que deja la cabecera para que la tarjeta quede centrada de
     verdad: apoyada arriba dejaba media pantalla vacía debajo y parecía que
     faltaba algo por cargar. */
  min-height: 75vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spaces.xl}rem
    ${({ theme }) => theme.spaces.l}rem;
`;
